import { Color as ColorEnum } from "@chessalpha/core";
import {
  IconButton,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import type { Challenge } from "@ssf/play-common";
import { timeControlString } from "@ssf/play-common";
import { challengesRef, remove, set } from "@ssf/play-components";
import {
  CircleOutline,
  CircleSlice4,
  CircleSlice8,
  Close,
} from "mdi-material-ui";
import { Link } from "react-router";

import { generatePath, usePlayer } from "../lib/index.js";

const ChallengeItemContent = ({ user, color, timeControl }: Challenge) => (
  <>
    {color === ColorEnum.white ? (
      <CircleOutline />
    ) : color === ColorEnum.black ? (
      <CircleSlice8 />
    ) : (
      <CircleSlice4 />
    )}
    <ListItemText sx={{ ml: 1 }}>{user.name}</ListItemText>
    <ListItemText sx={{ flex: "0 1 auto", mx: 2 }}>
      {timeControlString(timeControl)}
    </ListItemText>
  </>
);

export const ChallengeItem = ({
  challenge,
  gid,
  roomKey,
}: {
  challenge: Challenge;
  gid: string;
  roomKey: string;
}) => {
  const { player } = usePlayer();
  const isOwner = player?.uid === challenge.user.uid;
  const challengeRef = [challengesRef, roomKey, gid];

  if (isOwner) {
    return (
      <ListItem
        dense
        secondaryAction={
          <span>
            <IconButton onClick={() => remove(...challengeRef)}>
              <Close />
            </IconButton>
          </span>
        }
      >
        <ChallengeItemContent {...challenge} />
      </ListItem>
    );
  }

  return (
    <ListItemButton
      component={Link}
      to={generatePath("game", { room: roomKey, gid })}
      state={{ waitForGame: true }}
      dense
      disabled={!player}
      sx={{ pr: 6 }}
      onClick={() => {
        if (!player) {
          return;
        }
        set(
          ...challengeRef,
          "accepted",
        )({
          displayName: player.name,
          uid: player.uid,
        });
      }}
    >
      <ChallengeItemContent {...challenge} />
    </ListItemButton>
  );
};
